import { useState, useEffect, useCallback, useRef } from 'react';

import { isTopbarVisible } from '../../components/topbar/utils';
import { TOPBAR_HEIGHT } from '../../constants';

const NAVIGATION_PANE_HEIGHT = 60;
const SUBNAV_HEIGHT = 56;
const NAVBAR_HEIGHT = 60;
const TOP_SPACING = NAVBAR_HEIGHT + NAVIGATION_PANE_HEIGHT;
const HEADER_SUMMARY_HEIGHT = 54;
const HEADER_FILTERS_HEIGHT = 60;

type Props = {
  isManager: boolean;
  headerTabsHidden: boolean;
  headerStatsHidden: boolean;
  headerFiltersHidden: boolean;
};

type ScheduleDimensionsType = {
  topOffset: number;
};

export default function useScheduleDimensions({
  isManager,
  headerTabsHidden,
  headerStatsHidden,
  headerFiltersHidden,
}: Props): ScheduleDimensionsType {
  const getScheduleTopOffset = useCallback((): number => {
    const topbarHeight = isTopbarVisible() ? TOPBAR_HEIGHT : 0;
    let topOffset = topbarHeight + TOP_SPACING + (headerTabsHidden ? 0 : SUBNAV_HEIGHT);

    if (isManager && headerStatsHidden) {
      topOffset = topOffset + HEADER_SUMMARY_HEIGHT;
    }

    if (!isManager && !headerFiltersHidden) {
      topOffset = topOffset + HEADER_FILTERS_HEIGHT;
    }

    return topOffset;
  }, [isManager, headerTabsHidden, headerStatsHidden, headerFiltersHidden]);

  const [topOffset, setTopOffset] = useState(() => getScheduleTopOffset());
  const topOffsetRef = useRef(getScheduleTopOffset());

  useEffect(() => {
    const updatedTopOffset = getScheduleTopOffset();

    if (topOffsetRef.current !== updatedTopOffset) {
      setTopOffset(updatedTopOffset);
      topOffsetRef.current = updatedTopOffset;
    }
  }, [getScheduleTopOffset]);

  return {
    topOffset,
  };
}
